export const environment = {
  language: 'pt-BR',
  production: true,
  api: 'https://portalvesta-api.sequoialog.com.br/',
  signalR: 'https://portalvesta-api.sequoialog.com.br/',
  recaptchaKey: '6LfAzdoZAAAAAAPpFMRojCtNPhjHiE-4NeDsO1IK',
  googleMapsKey: 'AIzaSyBJYz-625mf5gmHW9ZhyO-avW9_2Qb8njQ',
  baseUrl: 'https://portalvesta.sequoialog.com.br/',
  debug: 'http://localhost:3000/'
};
